import styles from "./Badge.module.css";

interface BadgeProps {
	children: React.ReactNode;
	variant?: "default" | "primary" | "success" | "warning" | "danger" | "muted";
}

export function Badge({ children, variant = "success" }: BadgeProps) {
	return <span className={[styles.badge, styles[variant]].join(" ")}>{children}</span>;
}
